import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import * as types from '../types';

export const TrDraggableHandleWithPanelContext = createContext<{
  TrDraggableHandleWithPanelChildrenProps: types.TrDraggableHandleWithPanel.Children.Props | null;
  setTrDraggableHandleWithPanelChildrenProps: React.Dispatch<
    React.SetStateAction<types.TrDraggableHandleWithPanel.Children.Props | null>
  >;
} | null>(null);

export const useTrDraggableHandleWithPanelContext = () => {
  const context = useContext(TrDraggableHandleWithPanelContext);
  if (context === null) {
    throw new Error('TrDraggableHandleWithPanelContext must be present');
  }

  return context;
};

export const TrDraggableHandleWithPanelProvider: React.FC<{
  passedProps: types.TrDraggableHandleWithPanel.Children.Props;
}> = ({ passedProps, children }) => {
  const [
    TrDraggableHandleWithPanelChildrenProps,
    setTrDraggableHandleWithPanelChildrenProps,
  ] = useState<types.TrDraggableHandleWithPanel.Children.Props | null>(
    passedProps,
  );

  useEffect(() => {
    setTrDraggableHandleWithPanelChildrenProps(passedProps);
  }, [passedProps]);

  const context = useMemo(
    () => ({
      TrDraggableHandleWithPanelChildrenProps,
      setTrDraggableHandleWithPanelChildrenProps,
    }),
    [TrDraggableHandleWithPanelChildrenProps],
  );

  return (
    <TrDraggableHandleWithPanelContext.Provider value={context}>
      {children}
    </TrDraggableHandleWithPanelContext.Provider>
  );
};
